import { Global } from '@emotion/react'
import React from 'react'
import { QueryClientProvider } from 'react-query'

import { globalStyles, fonts } from 'assets/styles/global'
import AgentContainer from 'components/AgentContainer'
import App from 'components/App'
import { AuthProvider } from 'context/AuthContext'
import { gremlinQueryClient } from 'hooks/use-gremlin-query'
import theme from 'theme'

const Root = () => {
  return (
    <QueryClientProvider client={gremlinQueryClient}>
      <AuthProvider>
        <Global styles={[globalStyles(theme), fonts]} />
        <AgentContainer />
        <App />
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default Root
